import React from "react";

export default function WhatsAppFloat() {
  const phoneNumber = "919445771282"; // +91 9445771282 in international format without + and spaces
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <div className="whatsapp-float-container">
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          className="whatsapp-icon"
        >
          <path
            fill="currentColor"
            d="M16 0c-8.837 0-16 7.163-16 16 0 2.825 0.737 5.607 2.137 8.048l-2.137 7.952 7.933-2.127c2.42 1.37 5.173 2.127 8.067 2.127 8.837 0 16-7.163 16-16s-7.163-16-16-16zM16 29.467c-2.482 0-4.908-0.646-7.07-1.87l-0.507-0.292-5.243 1.405 1.409-5.235-0.322-0.532c-1.329-2.197-2.033-4.707-2.033-7.276 0-7.589 6.178-13.767 13.767-13.767s13.767 6.178 13.767 13.767-6.178 13.767-13.767 13.767zM21.713 18.068c-0.296-0.148-1.751-0.864-2.023-0.962-0.272-0.099-0.47-0.148-0.668 0.148s-0.767 0.962-0.941 1.16c-0.173 0.198-0.346 0.223-0.642 0.074-0.296-0.148-1.249-0.46-2.378-1.466-0.879-0.783-1.472-1.75-1.645-2.045s-0.018-0.456 0.13-0.604c0.133-0.133 0.296-0.346 0.444-0.519s0.198-0.296 0.296-0.494c0.099-0.198 0.049-0.371-0.025-0.519s-0.668-1.611-0.916-2.207c-0.242-0.579-0.487-0.5-0.668-0.51-0.173-0.008-0.371-0.01-0.569-0.01s-0.519 0.074-0.79 0.371c-0.272 0.296-1.037 1.013-1.037 2.472s1.062 2.868 1.21 3.066c0.148 0.198 2.095 3.2 5.076 4.487 0.709 0.306 1.263 0.489 1.694 0.626 0.712 0.226 1.36 0.194 1.872 0.118 0.571-0.085 1.751-0.716 1.999-1.407s0.247-1.283 0.173-1.407c-0.074-0.123-0.272-0.198-0.569-0.346z"
          />
        </svg>
        <span className="whatsapp-tooltip">Hi, How can I help you?</span>
      </a>
    </div>
  );
}
